import request from "@/utils/request";

export function getCart() {
  return request({
    url: "/trade/purchase/list",
    method: "get",
  });
}

export function editSpec(data) {
  return request({
    url: "/trade/purchase/update-spec",
    method: "post",
    data,
  });
}
export function editGoodsNum(data) {
  return request({
    url: "/trade/purchase/update-goodsNum",
    method: "post",
    data,
  });
}
export function delCartGoods(data) {
  return request({
    url: "/trade/purchase/delete-ids",
    method: "post",
    data,
  });
}
export function getCoupon(id) {
  return request({
    url: "/product/coupon/get-coupon/" + id,
    method: "put",
  });
}
export function batchGetCoupon(data) {
  return request({
    url: "/product/coupon/batch-coupon/claim",
    method: "put",
    data,
  });
}
export function purchaseInCart(data) {
  return request({
    url: "/trade/shopping/flash/purchase",
    method: "post",
    data,
  });
}
